/**
 * Sprint · Feb 2026 — Catalog Hub (tab "Catálogo" del Dashboard).
 *
 * Muestra un selector de 2 tarjetas: "Ropa y Uniformes" (consulta del catálogo
 * existente, read-only) y "Productos Personalizados" (módulo administrativo
 * P1). Este hub sólo se monta bajo el tab admin-only. La opción "Ropa y
 * Uniformes" abre `CatalogPicker` con `readOnly` para evitar cualquier
 * "Agregar al Estimate" desde el Catálogo General.
 */
import React, { useState } from "react";
import CatalogPicker from "@/components/CatalogPicker";
import ProductCatalogListPage from "./ProductCatalogListPage";
import ProductCatalogEditorPage from "./ProductCatalogEditorPage";

export default function CatalogHub() {
  // "hub" | "apparel" | "custom" | "custom-edit"
  const [view, setView] = useState("hub");
  const [editingId, setEditingId] = useState(null);

  if (view === "apparel") {
    return (
      <CatalogPicker
        open={true}
        readOnly={true}
        onClose={() => setView("hub")}
        onAdd={() => {}}
      />
    );
  }

  if (view === "custom") {
    return (
      <div className="space-y-3">
        <button
          data-testid="catalog-hub-back-custom"
          onClick={() => setView("hub")}
          className="text-sm underline text-[var(--text-secondary)] hover:text-black"
        >
          ← Volver al catálogo general
        </button>
        <ProductCatalogListPage
          onOpenProduct={(id) => {
            setEditingId(id);
            setView("custom-edit");
          }}
        />
      </div>
    );
  }

  if (view === "custom-edit") {
    return (
      <ProductCatalogEditorPage
        productId={editingId}
        onBack={() => {
          setEditingId(null);
          setView("custom");
        }}
      />
    );
  }

  const tiles = [
    {
      key: "apparel",
      title: "Ropa y Uniformes",
      desc: "Playeras, polos, gorras, bolsas y más. Consulta para mostrar al cliente.",
      icon: "👕",
      accent: "border-l-[#0E5FFF]",
      testId: "catalog-hub-tile-apparel",
    },
    {
      key: "custom",
      title: "Productos Personalizados",
      desc: "Catálogo interno de GP: Business Cards y futuros productos personalizados.",
      icon: "🧾",
      accent: "border-l-[#7C3AED]",
      testId: "catalog-hub-tile-custom",
    },
  ];

  return (
    <div data-testid="catalog-hub" className="space-y-6">
      <div>
        <div className="label-overline">CAT / HUB</div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
          Catálogo General
        </h2>
        <p className="text-sm text-[var(--text-secondary)]">
          Elegí qué catálogo consultar.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[var(--border)]">
        {tiles.map((tile) => (
          <button
            key={tile.key}
            data-testid={tile.testId}
            onClick={() => setView(tile.key)}
            className={`bg-white text-left p-5 hover:bg-[var(--bg)] border-l-4 ${tile.accent} transition-colors`}
          >
            <div className="text-3xl">{tile.icon}</div>
            <div className="font-display text-lg font-black tracking-tight mt-2">
              {tile.title}
            </div>
            <p className="text-sm text-[var(--text-secondary)] mt-1">{tile.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
